module.exports = __webpack_public_path__ + "img/Caravan64_ua.09dd4d70.webp";